import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { getSystemSetting, saveSystemSetting } from "@/features/admin/api";

/** System settings (`/admin/settings`) — the global e-Services-down toggle. */
export default function SystemSettingsPage() {
  const [eserviceDown, setEserviceDown] = useState(false);
  const [eserviceMsg, setEserviceMsg] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    getSystemSetting()
      .then((s) => {
        setEserviceDown(s.eserviceDown);
        setEserviceMsg(s.eserviceMsg);
      })
      .catch(() => toast.error("Couldn't load system settings."));
  }, []);

  async function save() {
    setBusy(true);
    try {
      await saveSystemSetting({ eserviceDown, eserviceMsg });
      toast.success("Saved.");
    } catch {
      toast.error("Couldn't save.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid max-w-2xl gap-6">
      <Card>
        <CardHeader>
          <CardTitle>IRS e-Services</CardTitle>
          <CardDescription>
            When on, downstream transcript/e-Services flows surface this banner and may disable
            live-pull actions.
          </CardDescription>
        </CardHeader>
        <CardContent className="grid gap-4">
          <div className="flex items-start gap-2">
            <Checkbox
              id="eservice-down"
              checked={eserviceDown}
              onCheckedChange={(c) => setEserviceDown(c === true)}
              className="mt-0.5"
            />
            <Label htmlFor="eservice-down" className="cursor-pointer font-normal">
              IRS e-Services is down
            </Label>
          </div>
          <div className="grid gap-2">
            <Label htmlFor="eservice-msg">Banner message</Label>
            <Textarea
              id="eservice-msg"
              rows={3}
              maxLength={800}
              value={eserviceMsg}
              onChange={(e) => setEserviceMsg(e.target.value)}
              placeholder="e.g. IRS e-Services is temporarily unavailable."
            />
          </div>
          <div>
            <Button disabled={busy} onClick={() => void save()}>
              {busy ? "Saving…" : "Save"}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
